<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-container fluid class="pa-0">
        <v-row dense>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <v-select 
                    dense
                    v-model="sickNo" 
                    :label="item.name" 
                    outlined 
                    hide-details
                    :items="sicks" 
                    item-text="name"
                    item-value="sickNo"
                    clearable
                    :readonly="!canEdit" />
            </v-col>
            <v-scale-transition>
                <v-col v-if="sickNo == null" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                        v-model="sickName" 
                        clearable
                        label="病名" 
                        outlined
                        :readonly="!canEdit"
                        hide-details 
                        type="text" 
                        dense />
                </v-col>
            </v-scale-transition>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        sickNo: null,
                        sickName: ""
                    }
                }
            },
            /** 作業記録項目種類 */
            item: null,
            /** 編集可否 */
            canEdit: false,
        },
        data: function () {
            return {
                sickNo: null,
                sickName: ""
            }
        },
        computed: {
            editValue: {
                get: function () {
                    return this.$props.value
                },
                set: function (v) {
                    this.$emit("input", v)
                }
            },
            sicks: function () {
                return this.$store.getters["managementItems/sicksArray"]
            },
        },
        watch: {
            // editValue: {
            //     handler: function (value, old) {
            //         console.log(value)
            //     },
            //     deep: true
            // },
            /**
             * 病気No.の監視
             */
            sickNo: function (value, old) {
                this.value.sickNo = value
                if (value == undefined) {
                    this.value.sickNo = null
                    this.sickName = ""
                }
                if (value != null) {
                    this.sickName = ""
                }
            },
            /**
             * 病名の監視
             */
            sickName: function (value, old) {
                if (value == undefined) {
                    this.value.sickName = ""
                } else {
                    this.value.sickName = value
                }
            }
        },
        created: function () {
            console.log("PlaceWorkRecorderSick", "created", this.editValue)
            if (this.editValue == "") {
                this.editValue = {
                    sickNo: null,
                    sickName: ""
                }
            }
            this.sickNo = this.editValue.sickNo
            this.sickName = this.editValue.sickName
        }
    }
</script>
